module.exports = __webpack_public_path__ + "media/images/top/bnr_line_shindan2-7ce78569736126434858ec4fda3079d6.jpg";